import React from "react"
import 'bootstrap/dist/css/bootstrap.min.css'
import './schools.css'
import { FormattedMessage } from "react-intl"
import PieChart from "./PieChart";
import "./schools-tuition-aid.css"

const TuitionStat = ({value, caption}) => {
  return (
    <div className="tuition-stat">
      <div className="tuition-stat-value">
        {value}
      </div>
      <div className="tuition-stat-caption">
        {caption}
      </div>
    </div>
  )
}

const SectionTuitionAid = ({ schoolData = {} }) => {

  const {
    averageFinancialAidCoverage = null,
    averageStudentNeedsMet = null,
    generalTuition = null,
    inStateTuition = null,
    outOfStateTuition = null,
    costBooksAndSuppliesCost = null,
    costRoomAndBoard = null,
    costRoomOnly = null,
    averageLoanAndWorkStudy = null,
    averageScholarship = null,
    averageFinancialAid = null,
  } = schoolData || {}

  const tuitionCoverage = averageFinancialAidCoverage ? Math.floor(averageFinancialAidCoverage) : 0
  const needsMet = averageStudentNeedsMet ? Math.floor(averageStudentNeedsMet) : 0

  const isMissingStudentNeeds = [
    averageFinancialAidCoverage,
    averageFinancialAid,
    averageLoanAndWorkStudy,
    averageScholarship,
  ].every(value => value === null || typeof(value) === undefined)

  return(
    <div className="tuition-and-aid-container">
    <div className="tuition-coverage-section">
      {(tuitionCoverage || generalTuition || inStateTuition || outOfStateTuition || costBooksAndSuppliesCost || costRoomAndBoard || costRoomOnly) && (
        <h3 className="tabs-section-heading"><FormattedMessage id="tuition-and-fees" defaultMessage="Tuition and Fees"/></h3>
      )}
      <div className="tuition-coverage" style={{ borderRightWidth: isMissingStudentNeeds && '0px'}}>
        { averageFinancialAidCoverage !== null && !isNaN(tuitionCoverage) && tuitionCoverage !== 0 &&
          <div className="tuition-data-container">
            <PieChart
              fractionFilled={tuitionCoverage}
              emptyColor="#74E4EB"
              fillColor="#0099D1"
            />
            <div className="tuition-data-values">
              <div className="percentage">{tuitionCoverage}%</div>
              <h3 className="percentage-caption">
                <FormattedMessage id="average-covered-by-financial-aid" defaultMessage="average covered by financial aid" />
              </h3>
            </div>
          </div>
        }

        {(generalTuition || inStateTuition || outOfStateTuition || costBooksAndSuppliesCost || costRoomAndBoard || costRoomOnly) &&
          <div className="tuition-stats-container">
            { inStateTuition !== null &&
              <TuitionStat
                value={`${inStateTuition?.symbol}${inStateTuition?.value?.toLocaleString('en')}`}
                caption={
                  !inStateTuition?.unit || inStateTuition?.unit === 'year'
                    ? <><FormattedMessage id="is-tuition" defaultMessage="In-state tuition"/>/<FormattedMessage id="year" defaultMessage="year"/></>
                    : <><FormattedMessage id="is-tuition" defaultMessage="In-state tuition"/> per {inStateTuition?.unit === 'credit hour' ? <FormattedMessage id="credit-hour" defaultMessage="credit hour"/> : inStateTuition?.unit}</>
                }
              />
            }
            { outOfStateTuition !== null &&
              <TuitionStat
                value={`${outOfStateTuition?.symbol}${outOfStateTuition?.value?.toLocaleString('en')}`}
                caption={
                  !outOfStateTuition?.unit || outOfStateTuition?.unit === 'year'
                    ? <><FormattedMessage id="os-tuition" defaultMessage="Out-of-state tuition"/>/<FormattedMessage id="year" defaultMessage="year"/></>
                    : <><FormattedMessage id="os-tuition" defaultMessage="Out-of-state tuition"/> per {outOfStateTuition?.unit === 'credit hour' ? <FormattedMessage id="credit-hour" defaultMessage="credit hour"/> : outOfStateTuition?.unit}</>
                }
              />
            }
            { generalTuition !== null && outOfStateTuition === null && inStateTuition === null &&
              <TuitionStat
                value={`${generalTuition?.symbol}${generalTuition?.value?.toLocaleString('en')}`}
                caption={
                  !generalTuition?.unit || generalTuition?.unit === 'year'
                    ? <><FormattedMessage id="g-tuition" defaultMessage="General tuition"/>/<FormattedMessage id="year" defaultMessage="year"/></>
                    : <><FormattedMessage id="g-tuition" defaultMessage="General tuition"/> per {generalTuition?.unit === 'credit hour' ? <FormattedMessage id="credit-hour" defaultMessage="credit hour"/> : generalTuition?.unit}</>
                }
              />
            }
            { costBooksAndSuppliesCost !== null &&
              <TuitionStat 
                value={`${costBooksAndSuppliesCost?.symbol}${costBooksAndSuppliesCost?.value?.toLocaleString('en')}`}
                caption={<FormattedMessage id="books-and-supplies" defaultMessage="Books & supplies"/>}
              />
            }
            { costRoomAndBoard !== null &&
              <TuitionStat 
                value={`${costRoomAndBoard?.symbol}${costRoomAndBoard?.value?.toLocaleString('en')}`}
                caption={ <FormattedMessage id="room-and-board" defaultMessage="Room & board"/>}
              />
            }
            { costRoomOnly !== null &&
              <TuitionStat 
                value={`${costRoomOnly?.symbol}${costRoomOnly?.value?.toLocaleString('en')}`}
                caption={<FormattedMessage id="room-only" defaultMessage="Room only"/>}
              />
            }
          </div>
        }
      </div>
    </div>

    <div className="financial-aid-section">
      {(needsMet || averageFinancialAid || averageLoanAndWorkStudy || averageScholarship) && (
        <h3 className="tabs-section-heading"><FormattedMessage id="financial-aid" defaultMessage="Financial Aid"/></h3>
      )}

      <div className="tuition-needs">
        { averageStudentNeedsMet !== null &&
          <div className="tuition-data-container">
            <PieChart
              fractionFilled={needsMet}
              emptyColor="#74E4EB"
              fillColor="#0099D1"
            />
            <div className="tuition-data-values">
              <div className="percentage">{needsMet}%</div>
              <h3 className="percentage-caption"> 
                <FormattedMessage id="of-students-receive-assistance" defaultMessage="of students receive assistance (loans, grants, scholarships)" />
              </h3>
            </div>
          </div>
        }

        {(averageFinancialAid || averageLoanAndWorkStudy || averageScholarship) &&
        <div className="tuition-stats-container">
          { averageFinancialAid !== null &&
            <TuitionStat 
              value={`${averageFinancialAid?.symbol}${averageFinancialAid?.value?.toLocaleString('en')}`}
              caption={<FormattedMessage id="avg-financial-aid-package" defaultMessage="Avg. Financial Aid Package"/>}
            />
          }
          { averageLoanAndWorkStudy !== null &&
            <TuitionStat 
              value={`${averageLoanAndWorkStudy?.symbol}${averageLoanAndWorkStudy?.value?.toLocaleString('en')}`}
              caption={<FormattedMessage id="avg-loan-work-study-aid" defaultMessage="Avg. Loan and Work Study Aid"/>}
            />
          }
          { averageScholarship !== null &&
            <TuitionStat 
              value={`${averageScholarship?.symbol}${averageScholarship?.value?.toLocaleString('en')}`}
              caption={<FormattedMessage id="avg-scholarship-grant-aid" defaultMessage="Avg. Scholarship/or Grant Aid"/>}
            />
          }
        </div>
        }
      </div>
    </div>
    </div>
  )
}

export default SectionTuitionAid
